"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventListenerManager {
    /**
     * Get all registers event listeners
     */
    static getListeners(eventTarget) {
        var _a;
        // certain libraries (ex. Sentry) will call addEventListener as global function and there will be no eventTarget.
        if (eventTarget === undefined) {
            return [];
        }
        const symbol = EventListenerManager.SYMBOL_HIDDEN;
        // @ts-ignore necessary as typescript doesn't understand the Symbol class
        const area = eventTarget[symbol] = (_a = eventTarget[symbol]) !== null && _a !== void 0 ? _a : { listeners: [] };
        return area.listeners;
    }
}
EventListenerManager.SYMBOL_HIDDEN = Symbol('hidden');
exports.default = EventListenerManager;
//# sourceMappingURL=EventListenerManager.js.map